import { useMemo, useState } from 'react';
import { sortByLabel } from '../../../../lib/utils';
import { AsyncCombobox } from '../async-combobox';
import { SearchableSelectProps } from './interface';

const EMPTY_VALUE = '__none__';

export function SearchableSelect({
  value,
  onValueChange,
  options,
  allowEmpty = false,
  emptyLabel = 'None',
  placeholder = 'Select an option...',
  searchPlaceholder = 'Search...',
  emptyMessage = 'No matching options.',
  disabled = false,
  isLoading = false,
  className,
}: SearchableSelectProps) {
  const [search, setSearch] = useState('');

  const sortedOptions = useMemo(() => sortByLabel(options, (option) => option.label), [options]);
  const query = search.trim().toLowerCase();
  const filteredOptions = query
    ? sortedOptions.filter((option) => option.label.toLowerCase().includes(query))
    : [
      ...(allowEmpty ? [{ value: EMPTY_VALUE, label: emptyLabel }] : []),
      ...sortedOptions,
    ];

  return (
    <AsyncCombobox
      value={value}
      options={filteredOptions}
      selectedOption={sortedOptions.find((option) => option.value === value)}
      search={search}
      onSearchChange={setSearch}
      onValueChange={(nextValue) => {
        setSearch('');
        onValueChange(nextValue === EMPTY_VALUE ? '' : nextValue);
      }}
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      emptyMessage={emptyMessage}
      disabled={disabled}
      isLoading={isLoading}
      className={className}
    />
  );
}

export type { SearchableSelectProps } from './interface';
